import React from 'react'
import CardUI from '../../widgets/layout/CardUI'
import MessageUI from '../../widgets/output/MessageUI'
import './AvatarInfo.css'

const AvatarInfoUI = ({context, messageList, avatarUrl, email, onCancel}) =>
  <CardUI context={context} className='usr_avtr_i'>
    <div className='g_flex_h'>
      <MessageUI messageList={messageList} messageKey='c_create_avatar_msg' args={[email]} />
      <div className="icon icon-times g_link" onClick={onCancel}></div>
    </div>
    <div className='g_flex_h block'>
      <span />
      <a href='https://gravatar.com' target='_blank' rel="noopener noreferrer">gravatar.com</a>
      <img src={avatarUrl} alt='' />
    </div>
  </CardUI>

export default AvatarInfoUI
